(function () {
    const navBp = breakpoints.md;
    const mqNav = window.matchMedia('(min-width: ' + navBp + 'px)');

    document.addEventListener("DOMContentLoaded", (event) => {
        const navigationBar = document.querySelector(".navigation-bar");
        const alertBar = document.querySelector(".is-alert-bar");
        const conditionSubNav = document.querySelector(".condition-sub-nav"); 

        if (conditionSubNav) {
            detectAlertBar(conditionSubNav);
        }

        if (navigationBar) {
            const burgerButtons = navigationBar.querySelectorAll("button.burger");
            const navPanelCtas = navigationBar.querySelectorAll(".navigation .navigation-items > li > button");
            const backdropEl = document.querySelector(".backdrop");

            detectScrollNavPosition(navigationBar);

            Array.prototype.forEach.call(burgerButtons, (el, i) => {
                const burgerButton = el;

                burgerButton.addEventListener("click", () => {
                    mobileNavigation.toggle(burgerButton, navigationBar);
                });

                backdropEl.addEventListener("click", () => {
                    mobileNavigation.close(burgerButton, navigationBar);
                });

                document.onkeydown = function (evt) {
                    if (evt.keyCode === keyList.escape) {
                        mobileNavigation.close(burgerButton, navigationBar);
                    }
                };

                if (matchMedia) {
                    mqNav.addListener(function () {
                        if (mqNav.matches) {
                            mobileNavigation.close(burgerButton, navigationBar);
                            navigationBar.querySelector('.navigation-group').inert = false;
                        } else {
                            mobileNavigation.close(burgerButton, navigationBar);
                            navigationBar.querySelector('.navigation-group').inert = true;
                        }
                    });
                }
            });

            Array.prototype.forEach.call(navPanelCtas, (el, i) => {
                const navPanelCta = el;
                const closeNavPanelCta = navPanelCta.closest('.has-sub-navigation').querySelector('.mobile-nav-back-cta');
                const parentEl = navPanelCta.closest(".has-sub-navigation");

                if (matchMedia) {
                    mqNav.addListener(function () {
                        if (mqNav.matches) {
                            navigationPanel.close(navPanelCta, navPanelCtas, parentEl);
                        } else {
                            navigationPanel.close(navPanelCta, navPanelCtas, parentEl);
                        }
                    });
                }

                navPanelCta.addEventListener("click", () => {
                    navigationPanel.toggle(navPanelCta, navPanelCtas, parentEl);
                });

                closeNavPanelCta.addEventListener("click", () => {
                    navigationPanel.close(navPanelCta, navPanelCtas, parentEl);
                });

                backdropEl.addEventListener("click", () => {
                    navigationPanel.close(navPanelCta, navPanelCtas, parentEl);
                });
            });

            document.onkeydown = function (evt) {
                if (evt.keyCode === keyList.escape) {
                    Array.prototype.forEach.call(navPanelCtas, (el, i) => {
                        const navPanelCta = el;
                        const parentEl = navPanelCta.closest(".has-sub-navigation");
                        navigationPanel.close(navPanelCta, navPanelCtas, parentEl);
                    });
                    Array.prototype.forEach.call(burgerButtons, (el, i) => {
                        const burgerButton = el;
                        mobileNavigation.close(burgerButton, navigationBar);
                    });
                }
            };
        }
    });

    const navigationPanel = {
        toggle: function(cta, ctas, parentEl) {
            const isParenElOpen = parentEl.classList.contains("is-active");

            if (isParenElOpen) {
                this.close(cta, ctas, parentEl);
            } else {
                Array.prototype.forEach.call(ctas, (el, i) => {
                    const navPanelCta = el;
                    const parentEl = navPanelCta.closest(".has-sub-navigation");
                    this.close(navPanelCta, ctas, parentEl);
                });
                this.open(cta, ctas, parentEl);
            }
        },
        close: function (cta, ctas, parentEl) {
            const subNavItems = parentEl.querySelector(".sub-navigation-item");
            parentEl.classList.remove("is-active");
            parentEl.closest(".navigation-bar").classList.remove("has-open-panel");
            document.querySelector(".backdrop").classList.remove("is-active");
            subNavItems.inert = true;
            Array.prototype.forEach.call(ctas, (el, i) => {
                el.inert = false;
            });
        },
        open: function (cta, ctas, parentEl) {
            const subNavItems = parentEl.querySelector(".sub-navigation-item");
            parentEl.classList.add("is-active");
            parentEl.closest(".navigation-bar").classList.add("has-open-panel");
            document.querySelector(".backdrop").classList.add("is-active");
            subNavItems.inert = false;
            if (window.innerWidth <= navBp) {
                Array.prototype.forEach.call(ctas, (el, i) => {
                    el.inert = true;
                });
            }
        }
    };

    const mobileNavigation = {
        toggle: function (cta, navigationContainer) {
            const isNavigationOpen = navigationContainer.classList.contains("is-active");

            if (isNavigationOpen) {
               this.close(cta, navigationContainer);
            } else {
                this.open(cta, navigationContainer);
            }
        },
        close: function (cta, navigationContainer) {
            const body = document.querySelector("body");
            const pageContainerDirectChildrens = document.querySelectorAll(".page-container > *:not(.navigation-bar-holder)");
            const navigationGroup = navigationContainer.querySelector('.navigation-group');
            const navPanelCtas = navigationGroup.querySelectorAll(".navigation .navigation-items > li > button");

            Array.prototype.forEach.call(navPanelCtas, (el, i) => {
                const parentEl = el.closest(".has-sub-navigation");
                navigationPanel.close(el, navPanelCtas, parentEl);
            });
            navigationContainer.classList.remove("is-active");
            cta.classList.remove("is-active");
            body.classList.remove('has-modal-open');
            Array.prototype.forEach.call(pageContainerDirectChildrens, (el, i) => {
                el.inert = false;
            });
            if (window.innerWidth <= navBp) {
                navigationGroup.inert = true;
            }
        },
        open: function (cta, navigationContainer) {
            const body = document.querySelector("body");
            const pageContainerDirectChildrens = document.querySelectorAll(".page-container > *:not(.navigation-bar-holder)");
            const navigationGroup = navigationContainer.querySelector('.navigation-group');

            navigationContainer.classList.add("is-active");
            navigationGroup.inert = false;
            cta.classList.add("is-active");
            body.classList.add('has-modal-open');
            if (window.innerWidth <= navBp) {
                Array.prototype.forEach.call(pageContainerDirectChildrens, (el, i) => {
                    el.inert = true;
                });
            }
        }
    };

    function detectScrollNavPosition(navBarEl) {
        window.addEventListener("scroll", function () {
            if (window.pageYOffset > 300) {
                navBarEl.classList.add("is-scroll");

            } else if (window.pageYOffset < 200) {
                navBarEl.classList.remove("is-scroll");

            }
        });
    }


    function detectAlertBar() {

        const alertBar = document.querySelector(".is-alert-bar");
        const conditionSubNav = document.querySelector(".condition-sub-nav");

        if (alertBar) {
            conditionSubNav.classList.add("alert-bar-active");

        } else {
            conditionSubNav.classList.remove("alert-bar-active");

        }
    }
    


})();